<template>
  <v-card>
    <v-card-title>
      <h1>Nuevo Propietario / Inquilino</h1>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <template v-if="!usuarioExistente">
            <v-flex xs12>
              <v-text-field
                label="Nombre"
                v-model="newPropietario.nombre"
                @input="forceUppercase($event, newPropietario, 'nombre')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Primer apellido"
                v-model="newPropietario.apellido1"
                @input="forceUppercase($event, newPropietario, 'apellido1')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Segundo apellido"
                v-model="newPropietario.apellido2"
                @input="forceUppercase($event, newPropietario, 'apellido2')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="email" v-model="newPropietario.email"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Teléfono móvil" type="number" v-model="newPropietario.tlf1"></v-text-field>
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs12>
              <h1 class="blue--text">Este usuario ya existe en la base de datos.</h1>
              <span class="grey--text">¿ Incluir en este inmueble ?</span>
            </v-flex>
            <v-flex xs12>
              <h2
                class="red--text"
              >{{usuarioExistente.nombre}} {{usuarioExistente.apellido1}} {{usuarioExistente.apellido2}}</h2>
            </v-flex>
            <v-flex xs12 v-if="usuarioExistente.email.length > 0">
              <span class="red--text">{{ usuarioExistente.email }}</span>
            </v-flex>
            <v-flex xs12 v-if="usuarioExistente.tlf1.length > 0">
              <span class="red--text">{{ usuarioExistente.tlf1 }}</span>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="closeDialog">Cerrar</v-btn>
      <v-btn
        :disabled="!isValid"
        color="primary"
        @click="saveUserDialog"
      >Guardar{{ usuarioExistente ? ' Existente' : ''}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const newPropietarioModel = {
  refCat: "",
  refInmueble: "",
  nombre: "",
  apellido1: "",
  apellido2: "",
  email: "",
  tlf1: "",
  usarExistente: false
};
export default {
  name: "NuevoPropietario",
  props: ["arrayUsers", "refInmueble", "catastroSelect"],
  data() {
    return {
      newPropietario: newPropietarioModel,
      existeUsuario: false,
    }
  },

  computed: {
    usuarioExistente() {
      if (!this.existeUsuario) {
        return false;
      }
      const datos = this.existeUsuario.data;
      const id = this.existeUsuario.idx;
      return {
        email: datos.admin && datos.admin.email ? datos.admin.email : "",
        tlf1: datos.private.tlf1,
        nombre: datos.private.nombre,
        apellido1: datos.private.apellido1,
        apellido2: datos.private.apellido2,
        id: id
      };
    },

    isValid() {
      return (
        this.isValidPhone(this.newPropietario.tlf1) ||
        this.isValidEmail(this.newPropietario.email)
      );
    },
  },

  mounted() {
    this.newPropietario = Object.assign({}, newPropietarioModel);
    this.existeUsuario = false;
    this.newPropietario.refCat = this.catastroSelect;
    this.newPropietario.refInmueble = this.refInmueble;
  },

  methods: {
    isValidEmail(email) {
      const regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; // /^[\w]+@{1}[\w]+\.[a-z]{2,3}$/;
      const compEmail = regEmail.test(email);
      if (compEmail) {
        return true;
      }
      return false;
    },
    
    isValidPhone(phone) {
      const reg = /^[6|7|8]{1}[\d]{8}$/; //(6|7)[ -]*([0-9][ -]*){8}'
      const compTel = reg.test(phone);
      if (compTel) {
        return true;
      }
      return false;
    },

    closeDialog() {
      // addUserDialog = false
      this.$emit("closeDialog")
    },

    forceUppercase(e, o, prop) {
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },

    searchUserEmail(email) {
      return this.arrayUsers.filter(i => i.data.admin.email === email);
    },

    searchUserTlf1(tlf1) {
      return this.arrayUsers.filter(i => i.data.private.tlf1 === tlf1);
    },

    saveUserDialog() {
      // 1 : Buscar si ya existe un propietario con ese email o ese tlf1
      if (!this.newPropietario.usarExistente) {
        let userExist = false;
        if (this.newPropietario.email) {
          userExist = this.searchUserEmail(this.newPropietario.email)[0];
          console.log("Buscar por email: ", userExist);
        }

        if (!userExist && this.newPropietario.tlf1) {
          userExist = this.searchUserTlf1(this.newPropietario.tlf1)[0];
          console.log("Buscar por tlf1: ", userExist);
        }

        this.existeUsuario = userExist;
        this.newPropietario.usarExistente = userExist ? userExist.idx : false;
        if (userExist) {
          return;
        }
      }
      // 2 : Guarda los datos
      console.log("Forzar el guardado...");
      // return;
      
      console.log("guardar:", JSON.stringify(this.newPropietario));
      this.$store.dispatch("addNewUserCatastro", this.newPropietario);

      this.$emit("savingUser")
      /* this.addUserDialog = false;
      this.dialogSendingMsg = "Guardando Usuario";
      this.dialogSending = true; */

      /* if (this.newPropietario.usarExistente) {
        console.log(`guardar el usuario existente: ${this.newPropietario.usarExistente}`);
        const addUser = functions.httpsCallable("addUserExistsCatastro");
        addUser(this.newPropietario)
          .then(data => {
            // eslint-disable-next-line no-console
            console.log(JSON.stringify(data));
            if (data.data.success) {
              this.$store.dispatch("buscaNuevoUserAdded", data.data.userId);
            } else {
              this.dialogSending = false;
            }
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log(error);
            this.dialogSending = false;
          });
      } else {
        this.$store.dispatch("addNewUserCatastro", this.newPropietario);
      } */
    },
  }
}
</script>
